import { render, staticRenderFns } from "./LeftNavbar.vue?vue&type=template&id=590ddda7&scoped=true"
import script from "./LeftNavbar.vue?vue&type=script&lang=js"
export * from "./LeftNavbar.vue?vue&type=script&lang=js"
import style0 from "./LeftNavbar.vue?vue&type=style&index=0&id=590ddda7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ddda7",
  null
  
)

export default component.exports